function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { visit, SKIP } from 'unist-util-visit';
/**
 * Remark plugin to handle video directives in markdown
 * Based on reference implementation from microblog-lms
 *
 * Supports format:
 * :::video
 * {src="url" title="Video Title"}
 * :::
 */ function remarkVideoPlugin() {
    console.log('[remarkVideoPlugin] Plugin initialized');
    return function(tree) {
        console.log('[remarkVideoPlugin] Processing tree');
        visit(tree, 'containerDirective', function(directiveNode, index, parent) {
            if (directiveNode.name === 'video') {
                console.log('[remarkVideoPlugin] Found video containerDirective:', JSON.stringify(directiveNode, null, 2));
                // New logic: Prioritize attributes from the directive node itself
                var attributes = directiveNode.attributes || {};
                console.log('[remarkVideoPlugin] Attributes from directive node:', JSON.stringify(attributes));
                // Fallback for old format: if no src, try parsing from children
                if (!attributes.src) {
                    console.log('[remarkVideoPlugin] No src in directive attributes, attempting to parse from children (legacy support).');
                    var rawContentFromDirective = '';
                    // Extract content from directive children
                    console.log('[remarkVideoPlugin] Full directive node:', JSON.stringify(directiveNode, null, 2));
                    if (directiveNode.children && directiveNode.children.length > 0) {
                        var firstChild = directiveNode.children[0];
                        console.log('[remarkVideoPlugin] Directive first child:', JSON.stringify(firstChild, null, 2));
                        if (firstChild.type === 'paragraph') {
                            rawContentFromDirective = firstChild.children.map(function(child) {
                                if (child.type === 'text') {
                                    return child.value;
                                }
                                if (child.type === 'link') {
                                    return child.url;
                                }
                                return '';
                            }).join('');
                        } else if (firstChild.type === 'text') {
                            rawContentFromDirective = firstChild.value || '';
                        } else {
                            console.warn('[remarkVideoPlugin] Video directive child is not a paragraph with text or a direct text node.');
                        }
                    } else {
                        console.warn('[remarkVideoPlugin] Video directive node has no children to parse for attributes.');
                    }
                    console.log('[remarkVideoPlugin] Extracted raw content:', rawContentFromDirective);
                    // Parse attributes from content
                    if (rawContentFromDirective) {
                        console.log('[remarkVideoPlugin] Directive content (raw):', JSON.stringify(rawContentFromDirective));
                        try {
                            var attrsString = rawContentFromDirective.trim();
                            console.log('[remarkVideoPlugin] Directive content (trimmed):', JSON.stringify(attrsString));
                            if (attrsString.startsWith('{') && attrsString.endsWith('}')) {
                                var innerContent = attrsString.substring(1, attrsString.length - 1);
                                console.log('[remarkVideoPlugin] Inner content for parsing:', JSON.stringify(innerContent));
                                var pairs = innerContent.match(/(\w+)="([^"]*)"/g);
                                if (pairs) {
                                    console.log('[remarkVideoPlugin] Matched pairs:', pairs);
                                    pairs.forEach(function(pair) {
                                        var matchResult = pair.match(/(\w+)="([^"]*)"/);
                                        if (matchResult) {
                                            var _matchResult = _sliced_to_array(matchResult, 3), _ = _matchResult[0], key = _matchResult[1], value = _matchResult[2];
                                            attributes[key] = value;
                                        }
                                    });
                                    console.log('[remarkVideoPlugin] Parsed attributes:', JSON.stringify(attributes));
                                } else {
                                    console.warn('[remarkVideoPlugin] No attribute pairs found in inner content:', innerContent);
                                }
                            } else {
                                console.warn('[remarkVideoPlugin] Trimmed attributes string does not start/end with {}:', attrsString);
                            }
                        } catch (e) {
                            console.error('[remarkVideoPlugin] Error parsing video directive attributes:', e);
                        }
                    }
                    console.log('[remarkVideoPlugin] Final attributes before check:', JSON.stringify(attributes));
                }
                if (!attributes.src) {
                    console.warn('[remarkVideoPlugin] Video directive found without a src attribute. Skipping transformation. Attributes:', JSON.stringify(attributes));
                    return SKIP;
                }
                // Check if this is an HLS stream
                var isHLS = attributes.src.includes('.m3u8') || attributes.src.includes('/hls/');
                // Modify the directive node in-place for rehype-react
                directiveNode.data = directiveNode.data || {};
                directiveNode.data.hName = 'video-player';
                directiveNode.data.hProperties = {
                    src: attributes.src,
                    title: attributes.title || 'Video',
                    poster: attributes.poster || '',
                    controls: true,
                    isHLS: isHLS,
                    width: '100%',
                    height: 'auto',
                    className: 'markdown-video-player'
                };
                // Clear children, as the content was the attribute string
                directiveNode.children = [];
                console.log('[remarkVideoPlugin] Modified directiveNode for video-player:', JSON.stringify(directiveNode, null, 2));
                return SKIP;
            }
        });
    };
}
export default remarkVideoPlugin;
